module.exports = __webpack_public_path__ + "img/okaloosa-island-pier-poster.489472bd.jpg";